module.exports = __webpack_public_path__ + "static/media/grid-item-a4.1bca261a.png";